import React from "react";
import TemplatesTable from "./templatesTable";
import ProtectedContent from "../../../components/protectedContent";

const TemplatesTab = () => {
  return (
    <ProtectedContent perms={["view_reporttemplate"]} showFallback>
      <TemplatesTable />
    </ProtectedContent>
  );
};

export default TemplatesTab;
